// extracted by mini-css-extract-plugin
export default {"body":"cardSection_body__UEiKu","line":"cardSection_line__O4Rb8","dishContainer":"cardSection_dishContainer__K6vzq","sectionContainer":"cardSection_sectionContainer__oygC3"};